import styled from 'styled-components'

import { colors, transitions } from '@/styles'

const offsetX = 0
const offsetY = 20
const activeOffsetY = 5

export const active = `
  color: ${colors.regular};
  transform: translate(${offsetX}px, ${activeOffsetY}px);
  font-size: 11px;
  font-weight: 700;
`

const Label = styled.label<{
  x?: number | string
  y?: number | string
  size?: number | string
  $disabled?: boolean
  hasError?: boolean
}>`
  transition: ${transitions.floatingLabel};
  position: absolute;
  pointer-events: none;
  font-size: ${props => `${props.size || 14}px`};
  letter-spacing: -0.2px;
  padding-left: 12px;
  top: 0;
  left: 0;
  ${props => `
    transform: translate(${props.x || offsetX}px, ${props.y || offsetY}px);
  `}

  color: ${props => (props.hasError ? colors.red : colors.mediumGrey)};
  ${props =>
    props.$disabled &&
    `
    opacity: 0.6;
  `};
`

export default Label
